import { Button } from "@Components/CustomButton/Button"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { ForumService } from "@Services/Knowledge/SavoirEtre/Forum.Service"
import React, { useState } from "react"
import { TouchableOpacity, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import { CommentInput } from "./CommentInput"
import styles from "./styles"

const TopicFooter = (props) => {
    const {
        forumId,
        toggleAnswerInput,
        forumContent,
        messageId,
        edition,
        setEdition,
        message,
        setMessage,
        sending,
        setSending,
        successfull,
        failed,
        openCreateMessageModal
    } = props

    const [disableBtn, setDisableBtn] = useState(true)

    const handleCancel = () => {
        if (!sending) {
            setEdition(false)
            setMessage("")
            toggleAnswerInput()
        }
    }

    console.log({ sending })

    const canSubmit = message?.trim()?.length > 0

    const handleSendMessage = () => {
        const payload = {
            subject: forumContent?.subject ?? "",
            content: message,
            forumId: forumId
        }

        if (canSubmit) {
            setSending(true)
            if (edition && messageId > 0) {
                ForumService.putForumAnswer({ ...payload, id: messageId })
                    .then(() => successfull("Modification avec succès."))
                    .catch((error) => error && failed())
            } else {
                ForumService.postForumAnswers(payload)
                    .then(() => successfull())
                    .catch((error) => error && failed())
            }
        }
    }

    return (
        <View style={{ marginVertical: 5 }}>
            {openCreateMessageModal ? (
                <View>
                    <CommentInput
                        setMessage={setMessage}
                        message={message}
                        height={50}
                        defaultPrimaryColor={baseColors.grey}
                        setDisableBtn={setDisableBtn}
                        disabled={sending}
                    />
                    <View style={styles.textInputBtn}>
                        <TouchableOpacity onPress={handleCancel}>
                            <OpenSansText
                                style={styles.cancel}
                                defaultFontFamily={baseFontFamily.OpenSansBold}
                                fontSize={14}
                            >
                                Annuler
                            </OpenSansText>
                        </TouchableOpacity>

                        <Button
                            disabled={sending || !canSubmit}
                            loading={sending}
                            onPress={handleSendMessage}
                            text={edition ? "Modifier" : "Envoyer"}
                            width="50%"
                            backgroundColor={baseColors.green.primary}
                            labelColor={"white"}
                        />
                    </View>
                </View>
            ) : (
                <Button
                    onPress={toggleAnswerInput}
                    text="Répondre"
                    width="60%"
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                    marginTop={0}
                />
            )}
        </View>
    )
}

export default TopicFooter
